import { Card, Row, Col, Form, Badge, Button } from 'react-bootstrap';

// An execution that is a reel off the shelf, not a run this launch will make.
//
// There is nothing to choose on it: the machine is PHANTOM and the length is
// whatever was taken from the reel, so both fields are locked and the card says
// where it came from instead of asking for anything.
//
// It exists as a component because the wizard drew it in THREE places already —
// the conductor cards, the flat execution list and the pre-stranding list — and
// a fourth was missing it entirely: a reduced-earth cable's per-rope list has
// its own renderer, which knew nothing about phantoms, so a reel used on
// `CYYF 3x25+16` added itself correctly and then drew as an ORDINARY card with
// an empty machine and an empty length. Reported 2026-10-22: "se adauga bine …
// dar imi creaza card gol de executie, nu se creaza card de phantom".
//
// @param exec     the execution row — `isPhantomSource` + `phantomId`
// @param onRemove called with no arguments; the caller knows its own indices
// @param warning  optional <ExecWarning/>, which needs the wizard's own context
const PhantomExecutionCard = ({ exec, onRemove, warning = null }) => (
  <Card className="border-info mb-2 shadow-sm" style={{ borderLeft: '5px solid #0dcaf0' }}>
    <Card.Header className="bg-info-subtle d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-2">
        <Badge bg="info">PHANTOM</Badge>
        <span className="fw-semibold">
          {Number(exec.plannedLength || 0).toLocaleString()} m
        </span>
        {(exec.phantomColor || exec.color) && (
          <Badge bg="dark">{exec.phantomColor || exec.color}</Badge>
        )}
        <span className="text-muted fs-10 font-monospace">{exec.phantomId}</span>
      </div>
      {onRemove && (
        <Button variant="outline-danger" size="sm" onClick={() => onRemove()}>
          Remove
        </Button>
      )}
    </Card.Header>

    <Card.Body className="py-2">
      <Row className="g-2">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Machine{warning}</Form.Label>
            <Form.Control
              size="sm"
              value="PHANTOM"
              readOnly
              disabled
              className="bg-light fw-semibold text-info"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Length (m) — from phantom</Form.Label>
            <Form.Control
              size="sm"
              type="number"
              value={exec.plannedLength || ''}
              disabled
              className="bg-light"
            />
          </Form.Group>
        </Col>
      </Row>

      {/* What the reel is, when it says. A stock reel of 1×Ø1.35 + 6×Ø1.7 and
          one of 1×Ø1.7 + 6×Ø2.14 are different conductors, and on a cable that
          is stranded twice the whole question is which rope this one feeds. */}
      {(exec.phantomSection || exec.phantomWireDiameter) && (
        <div className="text-muted fs-10 mt-1">
          {exec.phantomWireType && (
            <span className="me-2">{String(exec.phantomWireType).toUpperCase()}</span>
          )}
          {Array.isArray(exec.phantomWireDiameter) && exec.phantomWireDiameter.length > 0 && (
            <span className="me-2">
              {Array.isArray(exec.phantomNumberOfWires) &&
              exec.phantomNumberOfWires.length === exec.phantomWireDiameter.length
                ? exec.phantomWireDiameter
                    .map((d, i) => `${exec.phantomNumberOfWires[i]}×Ø${d}`)
                    .join(' + ')
                : `Ø${exec.phantomWireDiameter.join(', ')}`}
            </span>
          )}
          {exec.phantomSection != null && <span>sect. {exec.phantomSection}</span>}
        </div>
      )}

      {exec.phantomNote && (
        <div className="text-muted fs-10 mt-2 fst-italic">{exec.phantomNote}</div>
      )}
    </Card.Body>
  </Card>
);

export default PhantomExecutionCard;
